var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { commerce } from "../lib/commerce";
import { CartContext } from "@/hooks/useCartContext";
export default function CartContextProvider(_a) {
    var _this = this;
    var children = _a.children;
    var _b = useState([]), products = _b[0], setProducts = _b[1];
    var _c = useState(null), cart = _c[0], setCart = _c[1];
    var _d = useState({}), order = _d[0], setOrder = _d[1];
    var _e = useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    var fetchProducts = function () { return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.products.list()];
                case 1:
                    data = (_a.sent()).data;
                    setProducts(data);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchCart = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setCart;
                    return [4 /*yield*/, commerce.cart.retrieve()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAddToCart = function (productId, quantity) { return __awaiter(_this, void 0, void 0, function () {
        var item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.cart.add(productId, quantity)];
                case 1:
                    item = (_a.sent());
                    setCart(item);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateCartQty = function (productId, quantity) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.cart.update(productId, {
                        quantity: quantity,
                    })];
                case 1:
                    response = (_a.sent());
                    setCart(response);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveFromCart = function (productId) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.cart.remove(productId)];
                case 1:
                    response = (_a.sent());
                    setCart(response);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEmptyCart = function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.cart.empty()];
                case 1:
                    response = _a.sent();
                    setCart(response);
                    return [2 /*return*/];
            }
        });
    }); };
    var refreshCart = function () { return __awaiter(_this, void 0, void 0, function () {
        var newCart;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.cart.refresh()];
                case 1:
                    newCart = _a.sent();
                    setCart(newCart);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCaptureCheckout = function (checkoutTokenID, newOrder) { return __awaiter(_this, void 0, void 0, function () {
        var incomingOrder, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, commerce.checkout.capture(checkoutTokenID, newOrder)];
                case 1:
                    incomingOrder = _a.sent();
                    console.log(incomingOrder);
                    setOrder(incomingOrder);
                    refreshCart();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setErrorMessage(error_1.data.error.message);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchProducts();
        fetchCart();
    }, []);
    return (React.createElement(CartContext.Provider, { value: {
            products: products,
            cart: cart,
            order: order,
            errorMessage: errorMessage,
            onAddToCart: handleAddToCart,
            handleUpdateCartQty: handleUpdateCartQty,
            handleRemoveFromCart: handleRemoveFromCart,
            handleEmptyCart: handleEmptyCart,
            handleCaptureCheckout: handleCaptureCheckout,
            refreshCart: refreshCart,
        } }, children));
}
